import { module } from 'angular';
import { baseModuleId } from '../common/constants/base-module-id';
import { ColorDotsComponent } from './color-dots.component';
export var ColorDotsComponentNgModule = module(baseModuleId + ".color-dots", [])
    .component('colorDots', ColorDotsComponent);
